"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.string.split.js");

var _vue = require("vue");

var _indexUmd = _interopRequireDefault(require("~dist/index.umd.js"));

require("datatables.net-bs5");

require("datatables.net-buttons/js/dataTables.buttons.js");

require("datatables.net-buttons/js/buttons.html5.js");

require("datatables.net-buttons/js/buttons.print.js");

require("datatables.net-buttons-bs5");

require("datatables.net-select-bs5");

require("datatables.net-select-bs5/css/select.bootstrap5.min.css");

require("datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css");

// this demonstrate with buttons and responsive master/details row
// import buttons and plugins
// import the rest
var _default = (0, _vue.defineComponent)({
  name: 'App',
  components: {
    VdtnetTable: _indexUmd.default
  },
  data: function data() {
    var vm = this;
    return {
      options: {
        ajax: {
          url: 'https://jsonplaceholder.typicode.com/users',
          dataSrc: function dataSrc(json) {
            return json;
          }
        },
        buttons: ['copy', 'csv', 'print'],

        /*eslint-disable */
        dom: "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",

        /*eslint-enable */
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        stateSave: true
      },
      fields: {
        id: {
          label: 'ID',
          sortable: true
        },
        actions: {
          isLocal: true,
          label: 'Actions',
          defaultContent: '<a href="javascript:void(0);" data-action="edit" class="btn btn-primary btn-sm"><i class="mdi mdi-square-edit-outline"></i> Edit</a>' + '<span data-action="delete" class="btn btn-danger btn-sm"><i class="mdi mdi-delete"></i> Delete</span>'
        },
        name: {
          label: 'Name',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        username: {
          label: 'Username',
          sortable: false,
          searchable: true
        },
        email: {
          label: 'Email'
        },
        address1: {
          label: 'Address1',
          data: 'address',
          template: '{{ data.street }}, {{ data.suite }}'
        },
        address2: {
          label: 'Address2',
          data: 'address'
        },
        phone: {
          label: 'Phone'
        },
        website: {
          label: 'Website',
          render: function render(data) {
            return "https://".concat(data);
          }
        }
      },
      quickSearch: '',
      details: {}
    };
  },
  methods: {
    doLoadTable: function doLoadTable(cb) {
      $.getJSON('https://jsonplaceholder.typicode.com/users', function (data) {
        cb(data);
      });
    },
    doAlertEdit: function doAlertEdit(data) {
      window.alert("row edit click for item ID: ".concat(data.id));
    },
    doAlertDelete: function doAlertDelete(data, row, tr, target) {
      window.alert("deleting item ID: ".concat(data.id)); // row.remove() doesn't work when serverside is enabled
      // so we fake it with dom remove

      tr.remove();
      var table = this.$refs.table;
      setTimeout(function () {
        // simulate extra long running ajax
        table.reload();
      }, 1500);
    },
    doAfterReload: function doAfterReload(data, table) {
      window.alert('data reloaded');
    },
    doCreating: function doCreating(comp, el) {
      console.log('creating');
    },
    doCreated: function doCreated(comp) {
      console.log('created');
    },
    doSearch: function doSearch() {
      this.$refs.table.search(this.quickSearch);
    },
    doExport: function doExport(type) {
      var parms = this.$refs.table.getServerParams();
      parms.export = type;
      window.alert('GET /api/v1/export?' + jQuery.param(parms));
    },
    formatCode: function formatCode(zipcode) {
      return zipcode.split('-')[0];
    }
  }
});

exports.default = _default;